import React, { useState, useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import SvgList from '../SvgList';
import PlayListThumbnail from '../PlayListThumbnail';
import Button from '../../components/Button';
import { Menu, MenuItem, Paper } from '@material-ui/core';
import Popup from '../Popup';
import { playlistActions } from '../../actions';
import { playlistStore } from '../../store';
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { _showAlert, formatDateToDisplay } from '../../utils';
import { PLAN } from '../../constants/general.constant';
import { downloadFile } from '../../utils/generalUtils';
import { userActions } from '../../actions';

const PlaylistTable = ({
  data = [],
  type = 'UNLIMITED',
  onScroll,
  tableLoading,
  initialLoading,
  playlistType,
  userId,
  onPlaylistsUpdate,
  showAddButton = true,
  onAddClick,
  selectedUnlimited,
  setSelectedUnlimited,
  adding,
  setAdding,
  addPopupOpen,
  setAddPopupOpen,
}) => {
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const [popUp, setPopup] = useState({ isOpen: false, id: null });
  const [planPopUp, setPlanPopUp] = useState({ isOpen: false, id: null });
  // const [addPopupOpen, setAddPopupOpen] = useState(false);
  // const [selectedUnlimited, setSelectedUnlimited] = useState([]);
  // const [adding, setAdding] = useState(false);

  const history = useHistory();

  // Zustand Store
  const {
    unlimitedPlaylists,
    radioPlaylists,
    removeUnlimitedPlaylist,
    removeRadioPlaylist,
    addUnlimitedPlaylists,
    addRadioPlaylists,
    // setUnlimitedPlaylists,
  } = playlistStore((state) => {
    return {
      removeUnlimitedPlaylist: state.removeUnlimitedPlaylist,
      removeRadioPlaylist: state.removeRadioPlaylist,
      addUnlimitedPlaylists: state.addUnlimitedPlaylists,
      addRadioPlaylists: state.addRadioPlaylists,
      unlimitedPlaylists: state.unlimitedPlaylists,
      radioPlaylists: state.radioPlaylists,
      // setUnlimitedPlaylists: state.setUnlimitedPlaylists,
    };
  });

  const handleMenuItemClick = (event, option) => {
    setSelectedPlan(option.value);
    setAnchorEl(null);
    if (option.value !== type || playlistType === 'private') {
      setPlanPopUp({ ...planPopUp, isOpen: true });
    } else {
      copyPlaylist(planPopUp.id, option.value);
    }
  };

  const handlePlaylistDelete = (e, id) => {
    setLoading(true);
    const deletePlaylist = async () => {
      const deletePlaylistRes = await playlistActions.deletePlaylist(popUp.id);

      if (deletePlaylistRes.code === 'OK') {
        setPopup({ isOpen: false, id: null });
        removeUnlimitedPlaylist(popUp.id);
        removeRadioPlaylist(popUp.id);
        setLoading(false);
        _showAlert('Playlist deleted successfully', 'success');
      }
    };

    deletePlaylist();
  };

  const copyPlaylist = (id, plan) => {
    (async () => {
      setIsLoading(true);
      const res = await playlistActions.copyPlaylist(planPopUp.id, {
        copyTo: plan,
      });

      if (res.code === 'OK') {
        if (plan === 'UNLIMITED') {
          addUnlimitedPlaylists(res.data);
        } else {
          addRadioPlaylists(res.data);
        }
        setPlanPopUp({ isOpen: false, id: null });
        setIsLoading(false);
        _showAlert('Playlist copied successfully', 'success');
      }
    })();
  };

  const handleDownloadClick = (url) => {
    downloadFile(url);
    _showAlert('Your Playlist is Downloading', 'success');
  };

  const availableUnlimited = useMemo(() => unlimitedPlaylists.filter((u) => !data?.some((p) => p.id === u.id)), [unlimitedPlaylists, data]);

  const handleCheckboxChange = (pl, checked) => {
    if (checked) {
      setSelectedUnlimited([...selectedUnlimited, pl]);
    } else {
      setSelectedUnlimited(selectedUnlimited.filter((s) => s.id !== pl.id));
    }
  };

  const handleSaveAdd = async () => {
    if (!selectedUnlimited.length) return;
    setAdding(true);
    const playlistIds = selectedUnlimited.map((s) => s.id);
    const res = await userActions.addPlaylistsToUser(userId, { playlists: playlistIds });
    if (res.code === 'OK') {
      onPlaylistsUpdate();
      setAddPopupOpen(false);
      setSelectedUnlimited([]);
      _showAlert('Playlists added successfully', 'success');
    } else {
      _showAlert('Failed to add playlists', 'error');
    }
    setAdding(false);
  };

  useEffect(() => {
    if (onAddClick) {
      onAddClick();
    }
  }, [onAddClick]);

  return (
    <>
      <div style={{ display: 'flex', width: '100%', height: '100%', overflow: 'hidden', flex: 1 }}>
        {/* {playlistType === 'private' && showAddButton && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10, paddingRight: 10 }}>
            <Button onClick={handleOpenAdd} className="button primary">
              Add Playlist
            </Button>
          </div>
        )} */}
        <TableContainer className="tbl_wraper tbl_wrap" component={Paper} onScroll={onScroll}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className="result-with-image">Result</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Playlist Name</TableCell>
                <TableCell width={200}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.length === 0 && !initialLoading ? (
                <div className="table_initial_loader">
                  <h4
                    style={{
                      textAlign: 'center',
                      marginBottom: 20,
                      fontSize: 20,
                      lineHeight: '32px',
                      maxWidth: '60%',
                      marginInline: 'auto',
                    }}
                  >
                    No Playlist Found
                  </h4>
                </div>
              ) : (
                data?.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell className="result-with-image">
                      <div style={{ width: '100px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>{index + 1}</span>
                        <PlayListThumbnail src={row.thumbnail_img} name={row.name} style={{ borderRadius: 6 }} />
                      </div>
                    </TableCell>
                    <TableCell className="table-name-cell">{formatDateToDisplay(row.created_at)}</TableCell>
                    <TableCell>{row?.name}</TableCell>
                    <TableCell>
                      <div style={{ display: 'flex', columnGap: 15 }}>
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={() => downloadFile(`${process.env.REACT_APP_API_URL}/playlist/download/${row.id}`)}
                        >
                          {/* <SvgList name="download-icon" /> */}
                          <div
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDownloadClick(`${process.env.REACT_APP_API_URL}/playlist/download/${row.id}`)}
                          >
                            <SvgList name="download-icon" />
                          </div>
                        </div>
                        <div
                          button
                          style={{ cursor: 'pointer' }}
                          aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
                          onClick={(e) => {
                            setAnchorEl(e.currentTarget);
                            setPlanPopUp({ isOpen: false, id: row.id });
                          }}
                        >
                          <SvgList name="copy-icon" />
                        </div>
                        <div style={{ cursor: 'pointer' }} onClick={() => history.push(`/${type.toLowerCase()}-playlist/${row.id}`)}>
                          <SvgList name="edit-icon" />
                        </div>
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setPopup({ isOpen: true, id: row.id });
                          }}
                        >
                          <SvgList name="cancel-icon" />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
              {tableLoading && (
                <TableRow className="fetch_more_loader">
                  <CircularProgress />
                </TableRow>
              )}
              {initialLoading && (
                <div className="table_initial_loader">
                  <CircularProgress />
                </div>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Menu
          id="lock-menu"
          className="dropdown-menu"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {PLAN.map((option, index) => (
            <MenuItem
              style={{ padding: '15px 24px' }}
              key={option.value}
              // selected={index === selectedIndex}
              onClick={(event) => handleMenuItemClick(event, option)}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>

        <Popup open={popUp?.isOpen} onClose={() => !loading && setPopup({ isOpen: false, id: null })}>
          <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
            Are you sure, you want to delete this playlist?
          </h4>
          <div className="button-group" style={{ '--button-color': '#6900af' }}>
            <Button onClick={() => !loading && setPopup({ isOpen: false, id: null })} className="button transparent">
              Cancel
            </Button>

            <Button isLoading={loading} onClick={handlePlaylistDelete} className="button primary">
              Confirm
            </Button>
          </div>
        </Popup>

        <Popup open={planPopUp?.isOpen} onClose={() => !isLoading && setPlanPopUp({ isOpen: false, id: null })}>
          <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', marginInline: 'auto' }}>
            {playlistType !== 'private'
              ? `This is a ${type === 'UNLIMITED' ? 'Unlimited' : 'Radio'} Playlist. Duplicating it to ${
                  type === 'UNLIMITED' ? 'Radio' : 'Unlimited'
                } will make its song available to ${type === 'UNLIMITED' ? 'Radio' : 'Unlimited'} Users.`
              : `Are you sure you want to copy user's playlist to ${selectedPlan === 'UNLIMITED' ? 'Unlimited' : 'Radio'}`}
          </h4>
          <div className="button-group" style={{ '--button-color': '#6900af' }}>
            <Button onClick={() => !isLoading && setPlanPopUp({ isOpen: false, id: null })} className="button transparent">
              Cancel
            </Button>

            <Button isLoading={isLoading} onClick={() => copyPlaylist(planPopUp.id, selectedPlan)} className="button primary">
              Confirm
            </Button>
          </div>
        </Popup>

        <Popup open={addPopupOpen} onClose={() => !adding && setAddPopupOpen(false)}>
          <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px' }}>Select Unlimited Playlists to Add</h4>
          <TableContainer component={Paper} sx={{ maxHeight: 400, border: '1px solid #e0e0e0', borderRadius: '8px' }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox" />
                  <TableCell sx={{ fontWeight: 'bold' }}>Playlist</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Date Created</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {availableUnlimited?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                      No available unlimited playlists
                    </TableCell>
                  </TableRow>
                ) : (
                  availableUnlimited?.map((pl) => (
                    <TableRow
                      key={pl.id}
                      hover
                      onClick={() => handleCheckboxChange(pl, !selectedUnlimited?.some((s) => s.id === pl.id))}
                      sx={{ cursor: 'pointer' }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox color="primary" checked={selectedUnlimited?.some((s) => s.id === pl.id)} />
                      </TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                          <PlayListThumbnail src={pl.thumbnail_img} name={pl.name} style={{ width: 40, height: 40, borderRadius: 4 }} />
                          <span>{pl.name}</span>
                        </div>
                      </TableCell>
                      <TableCell>{formatDateToDisplay(pl.created_at)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="button-group" style={{ '--button-color': '#6900af', marginTop: '20px' }}>
            <Button onClick={() => !adding && setAddPopupOpen(false)} className="button transparent">
              Cancel
            </Button>
            <Button isLoading={adding} onClick={handleSaveAdd} className="button primary">
              Save
            </Button>
          </div>
        </Popup>
      </div>
    </>
  );
};

export default PlaylistTable;

